import { render, staticRenderFns } from "./proofCategoryTable.vue?vue&type=template&id=8d8c38a8"
import script from "./proofCategoryTable.vue?vue&type=script&lang=js"
export * from "./proofCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports